import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getAllDeployments } from 'Services';
import { RQ_ALL_DEPLOYMENTS, transformDeploymentHistoryData } from 'Utils';

function useDeploymentHistory(users?: UsersHashmap, shouldShowScheduledDeployment?: boolean) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_ALL_DEPLOYMENTS], () => getAllDeployments(templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0),
        refetchInterval: shouldShowScheduledDeployment && 60 * 1000,
        refetchOnReconnect: true,
        select: (data) => {
            return transformDeploymentHistoryData(data, users);
        }
    });
}
export default useDeploymentHistory;
